import isPromise from 'is-promise';
const now = Date.now();
let seed = 0;
const manager = {
    config: {
        duration: 4.5,
        top: 24,
        bottom: 24,
        placement: 'topRight',
        icons: {
            success: 'check',
            info: 'info',
            error: 'error',
            warning: 'warning',
            loading: 'loading',
        },
    },
    instances: new Map(),
    remove(key) {
        this.instances.forEach(instance => {
            if (isPromise(instance)) {
                instance.then(ins => ins.removeNotice(key));
            }
            else {
                instance.removeNotice(key);
            }
        });
    },
    clear() {
        const { instances } = this;
        instances.forEach(instance => {
            if (isPromise(instance)) {
                instance.then(ins => ins.destroy());
            }
            else {
                instance.destroy();
            }
        });
        instances.clear();
    },
    getUuid() {
        return `c7nNotification_${now}_${seed++}`;
    },
};
export default manager;
